module.exports = __webpack_public_path__ + "static/media/home-hero-cover.c3844145.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/home-hero-cover.jpg
// module id = 1426
// module chunks = 0